export default "__VITE_ASSET__f2afddca__"